module.exports = __webpack_public_path__ + "static/media/IT.f04de15f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/IT.svg
// module id = 2178
// module chunks = 7